import React from 'react';
export default function JSONArrow({ styling, arrowStyle = 'single', expanded, nodeType, onClick, }) {
    return (React.createElement("div", { ...styling('arrowContainer', arrowStyle), onClick: onClick },
        React.createElement("div", { ...styling(['arrow', 'arrowSign'], nodeType, expanded, arrowStyle) },
            '\u25B6',
            arrowStyle === 'double' && (React.createElement("div", { ...styling(['arrowSign', 'arrowSignInner']) }, '\u25B6')))));
}
